module.exports = __webpack_public_path__ + "static/media/person_1.f540a12d.png";